module.exports = __webpack_public_path__ + "assets/img/wode1.39ca58b5.png";